import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import AccessPage from "../Shared/accessPage";
import Pagination from "../Pagination/Pagination";
import { API_URL } from "../../utils/constant";

const AuditLogs = () => {
    const { orgId } = useParams();
    const [auditLogs, setAuditLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const vendorId = sessionStorage.getItem('vendorId');
    const vendorName = sessionStorage.getItem('vendorName');

    const id = useSelector(state => {
        if (orgId) {
          return orgId;
        } else {
          return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
        }
      });
   

    // Fetch audit logs
    const fetchAuditLogs = async () => {
        try {
            setLoading(true);
            setError(null);
            const session = localStorage.getItem("session");
            const headers = {
                Authorization: `Bearer ${session}`,
            };

            let url = `${API_URL}/get-audit-logs?page=${page}&limit=${limit}`;

            // Add organisationId if available
            if (id) {
                url += `&organisationId=${id}`;
            }

            const response = await axios.get(url, { headers });


            if (response.data && response.data.success) {
                setAuditLogs(response.data.data || []);
                setTotalItems(response.data.total || 0);
            } else if (response.data && response.data.data) {
                // Handle case where success might be false but data exists
                setAuditLogs(response.data.data || []);
                setTotalItems(response.data.total || response.data.data.length || 0);
            } else {
                setError("Failed to fetch audit logs");
            }
        } catch (err) {
            // console.error removed
            if (err.response) {
                // Server responded with error status
                setError(`Server error: ${err.response.status} - ${err.response.data?.message || 'Unknown error'}`);
            } else if (err.request) {
                // Request was made but no response received
                setError("No response from server. Please check your connection.");
            } else {
                // Something else happened
                setError("Failed to fetch audit logs. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    // Fetch audit logs when dependencies change
    useEffect(() => {
        if(id){
            fetchAuditLogs();
        }
    }, [page, limit, id]);


    return (
        <>
            <div className="container-fluid">
                <AccessPage></AccessPage>

                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1 className="welcome-text">Audit Logs</h1>
                            <nav aria-label="breadcrumb" className="mt-1">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        {vendorId ? (
                                            <>
                                                <Link
                                                    to="/vendor"
                                                    onClick={() => {
                                                        sessionStorage.clear();
                                                    }}
                                                >
                                                    Vendor Assessment
                                                </Link>
                                            </>
                                        ) : (
                                            <Link to="/" className="welcome-textSmall">
                                                Home
                                            </Link>
                                        )}
                                    </li>
                                    {vendorName && (
                                        <li
                                            className="breadcrumb-item active"
                                            aria-current="page"
                                            style={{ color: "white" }}
                                        >
                                            <Link to={`/dashboard/vendor/${vendorId}`}>
                                                {vendorName}
                                            </Link>
                                        </li>
                                    )}
                                    <li
                                        className="breadcrumb-item active"
                                        aria-current="page"
                                        style={{ color: "white" }}
                                    >
                                        Audit Logs
                                    </li>
                                </ol>
                                <br />
                            </nav>
                        </div>
                    </div>
                </div>


                {/* Audit Logs Table */}
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12">
                        <div className="card card_tableBox">
                            <div className="header">
                                <div className="body">
                                    <div className="table-responsive">
                                        {loading ? (
                                            <div className="text-center p-4">
                                                {/* <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                                <p className="mt-2">Loading audit logs...</p> */}
                                            </div>
                                        ) : (
                                            <>
                                                <table className="table table-custom spacing5 mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Module Name</th>
                                                            <th>Action Type</th>
                                                            <th>Performed By</th>
                                                            <th>Date</th>
                                                            <th>Targets</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {auditLogs?.length > 0 ? (
                                                            auditLogs.map((log, index) => (
                                                                <tr key={log._id || index}>
                                                                    <td>
                                                                        <strong>{log.moduleName || "N/A"}</strong>
                                                                    </td>
                                                                    <td>
                                                                        <span className={`badge badge-${getActionBadgeColor(log.actionType)}`}>
                                                                            {log.actionType || "N/A"}
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <code>{log.performedBy || "N/A"}</code>
                                                                    </td>
                                                                    <td>
                                                                        {log.createdAt ?
                                                                            moment(log.createdAt).format("DD-MM-YYYY") :
                                                                            "N/A"
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <div style={{ maxWidth: "300px", wordWrap: "break-word" }}>
                                                                            {Array.isArray(log.metadata?.targets) ? 
                                                                                log.metadata.targets.join(", ") : 
                                                                                log.metadata?.targets || "N/A"
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="6" className="text-center">
                                                                    {error ? (
                                                                        <div className="text-danger">
                                                                            <i className="fa fa-exclamation-triangle mr-2"></i>
                                                                            {error}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="text-muted">
                                                                            <i className="fa fa-info-circle mr-2"></i>
                                                                            No audit logs found
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>

                                                {/* Pagination */}
                                                {totalItems > 0 && (
                                                    <div className="d-flex justify-content-between align-content-center mt-3">
                                                        <div className="dataTables_paginate">
                                                            <Pagination
                                                                className="pagination-bar"
                                                                currentPage={page}
                                                                totalCount={totalItems}
                                                                pageSize={limit}
                                                                onPageChange={(page) => setPage(page)}
                                                            />
                                                        </div>
                                                        {totalItems > 10 && (
                                                            <select
                                                                value={limit}
                                                                onChange={(e) => {setPage(1); setLimit(Number(e.target.value))}}
                                                                className="form-control limitSelectBox"
                                                            >
                                                                <option value={10}>10 per page</option>
                                                                <option value={25}>25 per page</option>
                                                                <option value={50}>50 per page</option>
                                                                <option value={100}>100 per page</option>
                                                            </select>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

// Helper function to get badge color based on action
const getActionBadgeColor = (action) => {
    if (!action) return "secondary";

    const actionLower = action.toLowerCase();

    // Handle specific action types from the audit logs
    if (actionLower.includes('markasfalsepositive')) return "warning";
    if (actionLower.includes('markasincorrectip')) return "danger";
    if (actionLower.includes('create') || actionLower.includes('add')) return "success";
    if (actionLower.includes('update') || actionLower.includes('edit')) return "warning";
    if (actionLower.includes('delete') || actionLower.includes('remove')) return "danger";
    if (actionLower.includes('login') || actionLower.includes('auth')) return "info";
    if (actionLower.includes('export') || actionLower.includes('download')) return "primary";
    if (actionLower.includes('import') || actionLower.includes('upload')) return "info";

    return "secondary";
};

export default AuditLogs;
